import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { Field, reduxForm } from 'redux-form';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CardBody from '../../shared/components/CardBody';
import { connect } from 'react-redux';
import * as documentFormActions from '../actions/documentFormActions';
import * as documentStatesActions from '../actions/documentStatesActions';
import * as documentRevisionsActions from '../actions/documentRevisionsActions';
import bindActionCreators from 'redux/es/bindActionCreators';
import DropzoneComponent from 'react-dropzone-component';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import * as cookie from 'react-cookies';
import { AUTH_TOKEN } from '../../shared/utils/CookiesManager';
import DocumentStateSelect from '../../shared/components/DocumentStateSelect';
import ReactDOMServer from 'react-dom/server';
import UserRole from '../../shared/model/UserRole';
import DocumentState from '../../shared/model/DocumentState';
import { Int } from '../../shared/utils/StringUtils';
import UploadRequest from '../../profile/ws/UploadRequest';
import { CurrentUser } from '../../shared/model/CurrentUser';
import { FormText } from '../../shared/components/FormText';
import FormDate from '../../shared/components/FormDate';
import { FormSubmit } from '../../shared/components/FormSubmit';
import { ReduxFormUtils } from '../../shared/utils/ReduxFormUtils';
import { DatetimeParsers } from '../../shared/utils/DatetimeParsers';
import { DateFormatter } from '../../shared/formatters/DateFormatter';
import moment from 'moment/moment';

const FORM = {
    NAME: 'DocumentForm',
    FIELDS: {
        DOCUMENT_COMPANY_VALUE: 'company_value',
        DOCUMENT_CONSTRUCTION_VALUE: 'construction_value',
        DOCUMENT_WORKER_VALUE: 'worker_value',
        DOCUMENT_MACHINE_VALUE: 'machine_value',
        DOCUMENT_STATE_ID: 'document_state_id',
        DOCUMENT_TYPE_NAME: 'document_type.name',
        DOCUMENT_NAME: 'name',
        DOCUMENT_START_DATE: 'start_date',
        DOCUMENT_END_DATE: 'end_date',
        DOCUMENT_SUBMIT: 'submit',
    },
};

class DocumentForm extends React.Component {

    dropzone;

    constructor(props) {
        super(props);

        this.state = {
            files: this.props.initialValues.files,
            submitDisabled: false,
            showRequiredDocumentTextError: false,
            showUploadDocumentTextError: false,
        };
    }

    componentWillMount() {
        this.props.documentStatesActions.getDocumentStates();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {
            formValues,
        } = this.props;
        if ( formValues && formValues.document_state_id && nextProps && nextProps.formValues && nextProps.formValues.document_state_id ) {
            if ( parseInt(formValues.document_state_id) !== parseInt(nextProps.formValues.document_state_id) ) {
                if ( !this.documentIsRequired(parseInt(nextProps.formValues.document_state_id)) ) {
                    this.setState({
                        showRequiredDocumentTextError: false,
                        submitDisabled: false,
                    });
                }
            }
        }
    }

    documentIsRequired = (documentStateId) => {
        const {
            isMyDocument,
        } = this.props;
        const requiredStateDocuments = [
            DocumentState.VALIDATED,
            DocumentState.PENDING_VALIDATION,
            DocumentState.REFUSED,
        ];
        return requiredStateDocuments.includes(documentStateId) || isMyDocument;
    };

    onSubmit = (values) => {
        const {
            formValues,
        } = this.props;
        if ( this.documentIsRequired(parseInt(formValues.document_state_id)) && this.state.files.length === 0 ) {
            this.setState({
                showRequiredDocumentTextError: true,
                submitDisabled: true,
            });
        } else {
            this.props.documentRevisionsActions.createDocumentRevision(this.parserSubmit(values));
        }
    };

    parserSubmit = (values) => {
        const { files } = this.state;
        const { isMyDocument } = this.props;
        const deformatStartDate = values.start_date ? DateFormatter.deformat(values.start_date) : null;
        const deformatEndDate = values.end_date ? DateFormatter.deformat(values.end_date) : null;

        return {
            ...values,
            files: [...files],
            start_date: DatetimeParsers.parseInputDateToISODate(deformatStartDate),
            end_date: DatetimeParsers.parseInputDateToISODate(deformatEndDate),
            document_state_id: isMyDocument ? null : values.document_state_id,
        };
    };

    renderDocumentStateSelectField(field) {
        return <DocumentStateSelect field={field}/>;
    }

    renderParentField(document) {

        let label = '';
        let name = '';

        if ( document.company ) {
            label = I18nUtils.tr('TR_DOCUMENT_COMPANY') + ':';
            name = FORM.FIELDS.DOCUMENT_COMPANY_VALUE;
        }

        if ( document.construction ) {
            label = I18nUtils.tr('TR_DOCUMENT_CONSTRUCTION') + ':';
            name = FORM.FIELDS.DOCUMENT_CONSTRUCTION_VALUE;
        }

        if ( document.worker ) {
            label = I18nUtils.tr('TR_DOCUMENT_WORKER') + ':';
            name = FORM.FIELDS.DOCUMENT_WORKER_VALUE;
        }

        if ( document.machine ) {
            label = I18nUtils.tr('TR_DOCUMENT_MACHINE') + ':';
            name = FORM.FIELDS.DOCUMENT_MACHINE_VALUE;
        }

        return (
            <Field
                label={label}
                name={name}
                col="col-sm-8"
                component={FormText}
                readOnly={true}
                disabled={true}
            />
        );
    }

    renderDocumentStateField() {
        const { currentUser, documentStateOptions, document, isMyDocument, documentStateLastRevision } = this.props;

        const renderDocumentState = (documentState) => (
            <div className="col-sm-4">
                <label>{I18nUtils.tr('TR_DOCUMENT_STATE') + ':'}</label>
                <p><span className="active-state"
                         style={{ backgroundColor: '#' + documentState.color }}/> {documentState.name}</p>
            </div>
        );
        if ( documentStateLastRevision.id === DocumentState.ARCHIVED ) {
            return renderDocumentState(documentStateLastRevision);
        }

        switch ( currentUser.role() ) {
            case UserRole.SUPERADMIN:
            case UserRole.ADMIN:
            case UserRole.OUTSOURCES_MANAGER:
                const { formValues } = this.props;
                const key = ( formValues && formValues.document_state && formValues.document_state.id ) || '-1';
                return (
                    <Field
                        key={key}
                        label={I18nUtils.tr('TR_DOCUMENT_STATE') + ':'}
                        name={FORM.FIELDS.DOCUMENT_STATE_ID}
                        type={'selectSimple'}
                        colWidth="col-sm-4"
                        options={documentStateOptions}
                        component={this.renderDocumentStateSelectField}
                        disabled={isMyDocument}
                    />
                );
            case UserRole.CONTRACTORS_MANAGER:
            case UserRole.OUTSOURCES_VIEWER:
                return renderDocumentState(documentStateLastRevision);
            default:
                return '#222222';

        }
    }

    renderDropzone() {
        if ( this.props.allowUpload ) {
            const that = this;

            // acceptedFiles: "application/pdf",
            const dropzoneConfig = {
                addRemoveLinks: true,
                dictRemoveFile: 'Eliminar',
                dictRemoveFileConfirmation: '¿Está seguro de que quiere eliminar el archivo?',
                dictCancelUpload: 'Cancelar',
                dictCancelUploadConfirmation: '¿Está seguro de que quiere cancelar la subida?',
                headers: {
                    'Authorization': 'Bearer ' + cookie.load(AUTH_TOKEN),
                },
                acceptedFiles: this.props.document && this.props.document.document_type && this.props.document.document_type.mime_types ? this.props.document.document_type.mime_types.join() : '',
                previewTemplate: ReactDOMServer.renderToStaticMarkup(
                    <div class="dz-preview dz-file-preview dz-processing dz-success dz-complete">
                        <div class="dz-image">
                            <img
                                class={'dz-image-preview'}
                                alt={''}
                                src={''}
                            />
                        </div>
                        <div class="dz-details">
                            <div class="dz-size">
                                <span data-dz-size></span>
                            </div>
                            <a class={'link'} href={''} target={'_blank'}>
                                <div class="dz-filename">
                                    <span>Vista previa</span>
                                </div>
                            </a>
                        </div>
                        <div class="dz-progress">
                            <span class="dz-upload" data-dz-uploadprogress></span>
                        </div>
                        <div class="dz-error-message"><span data-dz-errormessage></span></div>
                        <div class="dz-success-mark">
                        </div>
                        <div class="dz-error-mark">
                        </div>
                    </div>,
                ),
                init: function() {

                    const mocks = that.state.files.map((file) => {
                        return {
                            name: file.name,
                            size: file.size,
                            type: file.mime_type,
                            file: file.file,
                            dataURL: file.file,
                            icon: file.file_type.icon,
                        };
                    });

                    for ( let i = 0; i < mocks.length; i++ ) {
                        let mock = mocks[i];
                        mock.accepted = true;

                        this.files.push(mock);
                        this.emit('addedfile', mock);
                        this.createThumbnailFromUrl(mock,
                            this.options.thumbnailWidth, this.options.thumbnailHeight,
                            this.options.thumbnailMethod, false, (thumbnail) => {
                                this.emit('thumbnail', mock, thumbnail);
                                this.emit('complete', mock);
                                this.emit('click', mock);
                            }, 'anonymous');
                    }
                },
            };

            const dropzoneComponentConfig = {
                postUrl: new UploadRequest().determineHostname() + ApiEndpoints.UPLOAD,
            };

            const dropzoneComponentEventHandlers = {
                init: (dropzone) => {
                    this.dropzone = dropzone;
                },
                success: (file, response) => {
                    if ( !response || !response.data ) {
                        this.dropzone.removeFile(file);
                        const files = this.state.files.filter((fileObj) => {
                            return fileObj.file !== file.file;
                        });
                        this.setState({ files: files });
                        this.setState({ showUploadDocumentTextError: true, submitDisabled: true });

                        return;
                    }

                    this.setState({ showUploadDocumentTextError: false });
                    file.file = response.data.url;

                    const fileObj = {
                        file: response.data.url,
                        name: file.name,
                        size: file.size,
                        mime_type: file.type,
                    };
                    this.setState({ files: [...this.state.files, fileObj], showRequiredDocumentTextError: false });
                },
                complete: (file) => {
                    const link = file.previewTemplate.getElementsByClassName('link');
                    link[0].href = file.file;
                    file.previewTemplate.setAttribute('style', 'background-color: unset');
                    const image = file.previewTemplate.getElementsByClassName('dz-image-preview');
                    image[0].src = file.icon;
                    this.setState({ submitDisabled: false });
                },
                canceled: (file) => {
                    this.setState({ submitDisabled: false });
                },
                addedfile: (file) => {
                    this.setState({ submitDisabled: true });
                },
                error: (file) => {
                    if ( !file.accepted ) {
                        Alert.error(I18nUtils.tr('TR_ERROR_FICHERO_NO_PERMITIDO'));
                        if ( this.dropzone ) {
                            this.dropzone.removeFile(file);
                        }
                    }
                },
                removedfile: (file) => {
                    const files = this.state.files.filter((fileObj) => {
                        return fileObj.file !== file.file;
                    });
                    this.setState({ files: files });
                    if ( this.documentIsRequired(parseInt(this.props.formValues.document_state_id)) && files.length === 0 ) {
                        this.setState({ showRequiredDocumentTextError: true, submitDisabled: true });
                    }
                },
            };

            return [
                <Row>
                    <div className="col-sm-12 form-group" test-id="form-dropzone">
                        <DropzoneComponent djsConfig={dropzoneConfig}
                                           config={dropzoneComponentConfig}
                                           eventHandlers={dropzoneComponentEventHandlers}>
                            <div className="dz-message">
                                <div className="drag-icon-cph">
                                    <i className="material-icons">touch_app</i>
                                </div>
                                <h3>Arrastra ficheros aquí o haz click para subir</h3>
                            </div>
                            <div className="fallback">
                                <input name="file" type="file" multiple/>
                            </div>
                        </DropzoneComponent>
                        {
                            this.state.showRequiredDocumentTextError &&
                            <label className={' error'}>{I18nUtils.tr('TR_CAMPO_OBLIGATORIO')}</label>
                        }
                        {
                            this.state.showUploadDocumentTextError &&
                            <label className={' error'}>{I18nUtils.tr('TR_HA_OCURRIDO_UN_ERROR_AL_ADJUNTAR_EL_DOCUMENTO')}</label>
                        }
                    </div>
                </Row>,
            ];
        }
    }

    renderDropzoneDisabled() {
        if ( !this.props.allowUpload ) {
            return (
                <div id="" className="row">
                    <div className="col-sm-12" test-id="form-dropzone">
                        <div className="filepicker dropzone dz-clickable dz-started">
                            {this.state.files.map((file, i) => {
                                return (
                                    <div key={i} className="dz-preview dz-complete dz-image-preview">
                                        <div className="dz-image">
                                            <img className="fill-height-120" alt={file.name}
                                                 src={file.file}/>
                                        </div>
                                        <div className="dz-details">
                                            <div className="dz-size">
                                                {this.renderFileSize(file.size)}
                                            </div>
                                            <a className="link"
                                               href={file.file}
                                               target="_blank">
                                                <div className="dz-filename">
                                                    <span>{I18nUtils.tr('TR_VISTA_PREVIA')}</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderFileSize(size) {
        let selectedSize = 0;
        let selectedUnit = 'B';

        if ( size > 0 ) {
            const units = ['TB', 'GB', 'MB', 'KB', 'B'];

            for ( let i = 0; i < units.length; i++ ) {
                let unit = units[i];
                let cutoff = Math.pow(1000, 4 - i) / 10;

                if ( size >= cutoff ) {
                    selectedSize = size / Math.pow(1000, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }

            selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
        }

        return <span data-dz-size="true"><strong>{selectedSize}</strong> {selectedUnit}</span>;
    }

    render() {
        const {
            document,
            handleSubmit,
            loading,
            allowUpload,
            initialValues,
            formValues,
        } = this.props;

        if ( !document ) return null;

        return (
            <Row clearfix>
                <Card loading={loading}>
                    <CardHeader title={I18nUtils.tr('TR_FICHA_DOCUMENTO').toUpperCase()}/>
                    <CardBody>
                        <form onSubmit={handleSubmit(this.onSubmit)}>
                            <Row>
                                {this.renderDocumentStateField()}
                                {this.renderParentField(document)}
                            </Row>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_DOCUMENT_TYPE') + ':'}
                                    name={FORM.FIELDS.DOCUMENT_TYPE_NAME}
                                    col="col-sm-4"
                                    component={FormText}
                                    disabled={true}
                                />
                                <Field
                                    label={I18nUtils.tr('TR_DOCUMENT_NAME') + ':'}
                                    placeholder={I18nUtils.tr('TR_DOCUMENT_NAME')}
                                    name={FORM.FIELDS.DOCUMENT_NAME}
                                    col="col-sm-8"
                                    component={FormText}
                                    disabled={true}
                                />
                            </Row>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_FECHA_DOCUMENTO') + ':'}
                                    name={FORM.FIELDS.DOCUMENT_START_DATE}
                                    type={'date'}
                                    col="col-md-6"
                                    disabled={!allowUpload}
                                    component={FormDate}
                                />
                                {
                                    !initialValues.document_type || !initialValues.document_type.expires ? null : (
                                        <Field
                                            label={I18nUtils.tr('TR_DOCUMENT_END_DATE') + ':'}
                                            name={FORM.FIELDS.DOCUMENT_END_DATE}
                                            type={'date'}
                                            col="col-md-6"
                                            disabled={!allowUpload}
                                            component={FormDate}
                                        />
                                    )
                                }
                            </Row>
                            <Row>
                                <div className="col-sm-12">
                                    <p>{document.document_type && document.document_type.notes ?
                                        document.document_type.notes : I18nUtils.tr(allowUpload ? 'TR_ADJUNTAR_DOCUMENTOS' : 'TR_DOCUMENTOS')}</p>
                                </div>
                            </Row>
                            {this.renderDropzone()}
                            {this.renderDropzoneDisabled()}
                            {
                                this.props.allowUpload ? (
                                    <Row>
                                        <div className="col-xs-8 p-t-5"/>
                                        <div className="col-xs-4">
                                            <Field
                                                label={I18nUtils.tr('TR_GUARDAR').toUpperCase()}
                                                name={FORM.FIELDS.DOCUMENT_SUBMIT}
                                                component={FormSubmit}
                                                disabled={this.state.submitDisabled}
                                            />
                                        </div>
                                    </Row>
                                ) : null
                            }
                        </form>
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

function validate(values, props) {
    const errors = {};

    if ( !props.isMyDocument && ( !values.document_state_id || values.document_state_id === '-1' ) ) {
        errors.document_state_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    if ( !values.name ) {
        errors.name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    // Campo obligatorio solamente si no tiene el estado de No aplica
    if ( values.document_state_id && Int(values.document_state_id) !== DocumentState.NO_APPLY && Int(values.document_state_id) !== DocumentState.PENDING_VALIDATION ) {
        if ( !values.start_date ) {
            errors.start_date = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
        } else if ( values.start_date && !DateFormatter.isValid(DateFormatter.deformat(values.start_date)) ) {
            errors.start_date = I18nUtils.tr('TR_FECHA_INVALIDA');
        }
    } else if ( values.start_date && !DateFormatter.isValid(DateFormatter.deformat(values.start_date)) ) {
        errors.start_date = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    // Campo obligatorio solamente si no tiene el estado de No aplica
    if ( values.document_state_id && Int(values.document_state_id) !== DocumentState.NO_APPLY && Int(values.document_state_id) !== DocumentState.PENDING_VALIDATION ) {
        if ( !values.end_date && props.initialValues && props.initialValues.expires === true ) {
            errors.end_date = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
        } else if ( values.end_date && !DateFormatter.isValid(DateFormatter.deformat(values.end_date)) && props.initialValues && props.initialValues.expires === true ) {
            errors.end_date = I18nUtils.tr('TR_FECHA_INVALIDA');
        }
    } else if ( values.end_date && !DateFormatter.isValid(DateFormatter.deformat(values.end_date)) ) {
        errors.end_date = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    return errors;
}

const mapStateToProps = (state, ownProps) => {
    const documentStateOptions = state
        .documentStates
        .documentStates
        .filter((documentState) => documentState.id !== DocumentState.ARCHIVED)
        .map((documentState) => {
            return {
                value: documentState.id,
                name: documentState.name,
                color: documentState.color,
            };
        });

    let initialValues = { ...ownProps.document, expires: false };

    if ( initialValues.document_type )
        initialValues.expires = initialValues.document_type.expires;

    if ( initialValues.company ) {
        const company = initialValues.company;
        initialValues.company_value = `${company.nif} - ${company.name}`;
    }

    if ( initialValues.construction ) {
        const construction = initialValues.construction;
        initialValues.construction_value = `${construction.code} - ${construction.name}`;
    }

    if ( initialValues.worker ) {
        const worker = initialValues.worker;
        initialValues.worker_value = `${worker.dni} - ${worker.name} ${worker.last_name}`;
    }

    if ( initialValues.machine ) {
        const machine = initialValues.machine;
        initialValues.machine_value = `${machine.name} - ${machine.brand} ${machine.model}`;
    }

    if ( initialValues.start_date ) {
        const formatDate = moment(initialValues.start_date).format('DDMMYYYY');
        const isValidDate = DateFormatter.isValid(formatDate);
        if ( isValidDate ) {
            initialValues.start_date = ReduxFormUtils.dateFormatter(formatDate);
        }
    }

    if ( initialValues.end_date ) {
        const formatDate = moment(initialValues.end_date).format('DDMMYYYY');
        const isValidDate = DateFormatter.isValid(formatDate);
        if ( isValidDate ) {
            initialValues.end_date = ReduxFormUtils.dateFormatter(formatDate);
        }
    }

    initialValues.document_state_id = initialValues.document_state && initialValues.document_state.id;
    const lastDocumentRevision = state.documentRevisions.lastRevision;
    if ( lastDocumentRevision ) {
        initialValues.document_state_id = lastDocumentRevision.document_state.id;
        initialValues.document_state = lastDocumentRevision.document_state;
        if ( lastDocumentRevision.start_date ) {
            const formatDate = moment(lastDocumentRevision.start_date).format('DDMMYYYY');
            const isValidDate = DateFormatter.isValid(formatDate);
            if ( isValidDate ) {
                initialValues.start_date = ReduxFormUtils.dateFormatter(formatDate);
            }
        }
        if ( lastDocumentRevision.end_date ) {
            const formatDate = moment(lastDocumentRevision.end_date).format('DDMMYYYY');
            const isValidDate = DateFormatter.isValid(formatDate);
            if ( isValidDate ) {
                initialValues.end_date = ReduxFormUtils.dateFormatter(formatDate);
            }
        }
    }

    const currentUser = CurrentUser.fromReduxState(state);
    const isMyDocument = currentUser.myCompanyId() === ownProps.document.company.id;
    const documentStateLastRevision = isMyDocument && lastDocumentRevision ?
        lastDocumentRevision.document_state : ownProps.document.document_state;

    let currentStartDateValue = state.form[FORM.NAME] && state.form[FORM.NAME].values && state.form[FORM.NAME].values.start_date;
    if ( currentStartDateValue ) {
        const isValidDate = DateFormatter.isValid(currentStartDateValue);
        if ( isValidDate ) {
            state.form[FORM.NAME].values.start_date = ReduxFormUtils.dateFormatter(currentStartDateValue);
        }
    }
    let currentEndDateValue = state.form[FORM.NAME] && state.form[FORM.NAME].values && state.form[FORM.NAME].values.end_date;
    if ( currentEndDateValue ) {
        const isValidDate = DateFormatter.isValid(currentEndDateValue);
        if ( isValidDate ) {
            state.form[FORM.NAME].values.end_date = ReduxFormUtils.dateFormatter(currentEndDateValue);
        }
    }

    return {
        initialValues,
        formValues: ReduxFormUtils.selectFormValues(state, FORM.NAME),
        loading: state.formDocument.loading,
        documentStateOptions: documentStateOptions,
        currentUser,
        isMyDocument,
        documentStateLastRevision,
    };
};

const mapDispatchToProps = dispatch => ( {
    documentFormActions: bindActionCreators(documentFormActions, dispatch),
    documentStatesActions: bindActionCreators(documentStatesActions, dispatch),
    documentRevisionsActions: bindActionCreators(documentRevisionsActions, dispatch),
} );

export const DocumentFormCard = connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
        {
            validate,
            form: FORM.NAME,
            enableReinitialize: true,
        },
    )(DocumentForm),
);

DocumentFormCard.propTypes = {
    document: PropTypes.object.isRequired,
    allowUpload: PropTypes.bool,
};

DocumentFormCard.defaultProps = {
    allowUpload: true,
};



// WEBPACK FOOTER //
// ./src/app/documents/components/DocumentFormCard.jsx